function formatCurrency(currency: number, decimalNumbers: number, currencySign?: string): string {

  const cs: string = currencySign ? currencySign : '';

  return cs + currency.toFixed(decimalNumbers).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

export {
  formatCurrency
}